export default __webpack_public_path__ + "static/media/nb-m.8d680ef0.jpg";